import React, { memo, type ComponentPropsWithoutRef, forwardRef } from 'react';
import EditorAddIcon from '@atlaskit/icon/core/migration/add--editor-add';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { ThemedButton } from '@atlassian/jira-project-theme-components/src/ui/themed-button/ThemedButton.tsx';
import { UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_SUBTLE_VAR } from '@atlassian/navigation-kit-common';
import { getIsSoftwareThemingM2Enabled } from '@atlassian/jira-project-theme-providers/src/utils/getIsSoftwareThemingEnabled.tsx';
import messages from './messages.tsx';

const AddTabTrigger = forwardRef<
	HTMLElement,
	ComponentPropsWithoutRef<typeof ThemedButton> & {
		noTooltip?: boolean;
		presentational?: boolean;
	}
>(({ presentational, noTooltip, ...props }, ref) => {
	const { formatMessage } = useIntl();
	const button = (
		<ThemedButton
			spacing="none"
			appearance="subtle"
			role={presentational ? 'presentation' : undefined}
			name={formatMessage(messages.addTabTriggerLabel)}
			ref={ref}
			{...props}
		>
			<EditorAddIcon
				LEGACY_size="medium"
				spacing="spacious"
				label={formatMessage(messages.addTabTriggerLabel)}
			/>
		</ThemedButton>
	);
	return (
		<Box xcss={[boxStyles, getIsSoftwareThemingM2Enabled() && themingM2Styles]}>
			{noTooltip ? (
				button
			) : (
				<Tooltip content={formatMessage(messages.addTabTriggerLabel)} hideTooltipOnMouseDown>
					{button}
				</Tooltip>
			)}
		</Box>
	);
});

export default memo(AddTabTrigger);

const boxStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: '0',
	position: 'relative',
	alignSelf: 'center',
});

const themingM2Styles = xcss({
	// @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	'--project-color-text-subtle': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_SUBTLE_VAR}, ${token('color.text')})`,
});
